<div [ngStyle]="{ 'display' : multipathToolService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngMultipathToolController" [ngClass]="[this.multipathToolService.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngMultipathToolController" #ngMultipathToolController="ngForm" id="multipathToolForm" style="height: 600px">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Multipath Input</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
              <table>
                <thead>
                  <tr>
                    <th scope="col">Legend</th>
                    <th scope="col">Latitude</th>
                    <th scope="col">Longitude</th>
                    <th scope="col">Delay [us]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let elem of this.multipathToolService.multipathElems; let i = index" (click)="check(i)"
                  [class.highlighted]="i == this.multipathToolService.selectedIndex">
                    <td [ngStyle]="{'background-color': elem.color? elem.color : ''}"></td>
                    <td>
                      <input style="width:75%;" type="number" [(ngModel)]="elem.latitude" [ngModelOptions]="{standalone: true}" (change)="elem.latitude = +$event.target.value">
                    </td>
                    <td>
                      <input style="width:75%" type="number" [(ngModel)]="elem.longitude" [ngModelOptions]="{standalone: true}"(change)="elem.longitude = +$event.target.value">
                    </td>
                    <td>
                      <input style="width:75%" type="number" [(ngModel)]="elem.delay" [ngModelOptions]="{standalone: true}" (change)="elem.delay = +$event.target.value">
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="add()">Add</a>
                <a (click)="deleteElement()" >Delete</a>
                <a  (click)="deleteAll()">Delete All</a>
                <a (click)="display()" >Display</a>
              </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
